import {Lesson, mapHomeWorkTypes} from "../model/courses/Lesson";

export function mapTag(key : string) : string {
    let res : string = Lesson.getDeckTitle(key);
    if(res.length > 0 )return  res;
    res = mapHomeWorkTypes(key);
    if(res.length > 0 )return  res;
    return key;
}
